<div class="motors-maintenance">
    <tg-info-box
        compact
        tgStyle="warning">
        <tg-info-box-heading>
            Motorboats listing is undergoing scheduled maintenance
        </tg-info-box-heading>
        Try listing again later today. We apologise for any inconvenience.
        <div class="motors-maintenance__info-box-action">
            <tg-info-box-actions>
                <a href="https://www.trademe.co.nz/a/motors">Back to Trade Me Motors</a>
            </tg-info-box-actions>
        </div>
    </tg-info-box>
</div>
